import {
  FF_IGNORE_REALTIME_FOR_TRIPS,
  IGNORE_REALTIME_FOR_TRIPS_LINEDIRECTIONIDS,
} from '../constants'

export const mapTheoreticalPassage = ({
  lijn,
  bestemming,
  tijdstipAsLong,
} = {}) => {
  return {
    vertrekTheoretischeTijdstip: tijdstipAsLong,
    aankomstTheoretischTijdstip: tijdstipAsLong,
    aankomstTheoretischeTijdstip: tijdstipAsLong,
    predictionStatussen: lijn?.predictionStatussen?.filter(
      (x) => x === 'DELETED',
    ),
    lijnRichting: lijn.omschrijving,
    lijnNummerPubliek: lijn.lijnNummerPubliek,
    richtingCode: lijn.richtingCode,
    bestemming,
    kleurAchterGrond: lijn.kleurAchterGrond,
    kleurAchterGrondRand: lijn.kleurAchterGrondRand,
    kleurVoorGrond: lijn.kleurVoorGrond,
    eindHalte: lijn.eindHalte,
  }
}

export const mapTheoreticalPassages = (theoreticalPassages) => {
  return theoreticalPassages
    .map((theoreticalPassages) => theoreticalPassages.halteDoorkomsten)
    .flat()
    .map((passage) => mapTheoreticalPassage(passage))
}

// strip realtime from passage with given lineDirectionIds, when FF_IGNORE_REALTIME_FOR_TRIPS is enabled ('true')
export function stripRealtimeFromPassage(passage, lineDirectionId = '') {
  const lineId = lineDirectionId.substr(0, 4)
  const directionCode = parseInt(lineDirectionId.substr(4, 5), 10) % 2 // convert even to 0 & odd to 1
  const correctLineDirection = `${lineId}${directionCode}`
  const linedirectionIdsToStrip =
    IGNORE_REALTIME_FOR_TRIPS_LINEDIRECTIONIDS.replace(/\s/g, '').split(',')

  if (
    FF_IGNORE_REALTIME_FOR_TRIPS === 'true' &&
    linedirectionIdsToStrip.includes(correctLineDirection)
  ) {
    const {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      vertrekRealtimeTijdstip: _vertrekRealtimeTijdstip,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      aankomstRealtimeTijdstip: _aankomstRealtimeTijdstip,
      ...strippedPassage
    } = passage
    console.debug('Stripped realtime from lineDirection:', correctLineDirection)
    return {
      ...strippedPassage,
      predictionStatussen: ['NOREALTIME'],
    }
  } else {
    return passage
  }
}

export const mappedTransportType = (transportType) => {
  if (transportType === '0') {
    return 'BUS'
  } else if (transportType === '1') {
    return 'TRAM'
  } else {
    return undefined
  }
}

export function mapTripToLijn(trip) {
  if (!trip) {
    return undefined
  }
  const passage = trip.passages[0]
  const lineDirection = trip.lineDirection
  if (!lineDirection?.description || passage.scheduleType === 'NOT_SERVED') {
    return undefined
  }

  const mappedPassage = {
    predictionStatussen: passage.realtimeStatuses,
    vertrekTheoretischeTijdstip: passage.plannedPassage.departureEpoch,
    aankomstTheoretischTijdstip: passage.plannedPassage.arrivalEpoch,
    vertrekRealtimeTijdstip: passage.realtimePassage?.departureEpoch,
    aankomstRealtimeTijdstip: passage.realtimePassage?.arrivalEpoch,
    lijnNummerPubliek: lineDirection.publicLineNr,
    lijnRichting: lineDirection.description,
    bestemming: trip.planningDestination,
    richtingCode: lineDirection.directionCode,
    kleurAchterGrond: lineDirection.lineColor.background,
    kleurAchterGrondRand: lineDirection.lineColor.backgroundBorder,
    kleurVoorGrond: lineDirection.lineColor.foreground,
    merged: passage.merged,
    eindHalte: passage.lastStop,
    transportType: mappedTransportType(lineDirection.transportType),
  }
  return stripRealtimeFromPassage(mappedPassage, lineDirection.id)
}

export function mapTripsToLijnen(trips) {
  return trips.map((trip) => mapTripToLijn(trip)).filter(Boolean)
}

export function isTripValid(trip, includeEindHaltes, serverTijd) {
  if (!includeEindHaltes && trip.eindHalte) {
    return false
  }

  if (trip.merged) {
    return true
  }

  return (
    (trip.vertrekRealtimeTijdstip || trip.vertrekTheoretischeTijdstip) >=
    serverTijd
  )
}

export function mapStopIdToDummyStop(stopId) {
  return {
    id: stopId,
    shortDescription: stopId,
    longDescription: stopId,
  }
}
